import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';
import { ConfirmationService } from 'primeng/primeng';
import { SelectItem,MenuItem } from 'primeng/primeng';
import { GeofenceService } from '../services/geofence.service';
import { UserService } from '../services/user.service';
import { DeviceService } from '../services/device.service';
import { PositionService } from '../services/position.service';

@Component({
  selector: 'app-geofence',
  templateUrl: './geofence.component.html',
  styleUrls: ['./geofence.component.css'],
  providers: [ConfirmationService]
})
export class GeofenceComponent implements OnInit {

  steps :MenuItem[];
  activeIndex: number = 1;
  msgs: Message[] = [];
  position: any;
  geofence: any;
  geofences : any [];
  overlays: any[];
  options: any;
  displayAdd: boolean = false;
  displayEdit: boolean = false;
  displayGeofence: boolean = false;
  displayDevices: boolean = false;
  types: SelectItem[];
  blockedDocument: boolean = false;
  map: google.maps.Map;
  circle: google.maps.Circle;
  line : google.maps.Polyline;
  polygon: google.maps.Polygon;
  devicesAvailables: any[];
  devicesSelecteds : any[];
  typeFilter: SelectItem[];

  constructor(private geofenceService : GeofenceService,private userService: UserService,private confirmationService: ConfirmationService,private deviceService:DeviceService,private positionService:PositionService) { }

  ngOnInit() {
    this.typeFilter = [
            {label: 'TODOS', value: null },
            {label: 'Círculo', value: 'C'},
            {label: 'Polígono', value: 'P'},
            {label: 'Lineal', value: 'L'}
        ];

    this.init();
    this.types = [
      {label: 'Circulo', value: 'C'},
      {label: 'Poligono', value: 'P'},
      {label: 'Lineal', value: 'L'}
    ];
    this.activeIndex = 0;
    this.steps = [{
      label: 'Registrar Geocerca',
      command: (event: any) => {
        this.activeIndex = 0;
      }
    },
    {
      label: 'Configurar Geocerca',
      command: (event: any) => {
        this.activeIndex = 1;
      }
    },
    {
      label: 'Asignar Equipo',
      command: (event: any) => {
        this.activeIndex = 2;
      }
    }];
  }

  init(){
    this.activeIndex = 0;
    this.circle = null;
    this.line = null;
    this.polygon = null;
    this.overlays=[];
    this.options = {
      zoom: 13
    };
    this.devicesAvailables = [];
    this.devicesSelecteds = [];
    this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devicesAvailables.push(item);
      });
      this.positionService.getLastPosition(response.devices[0].idDevice).then(data => {
        let response: any = data;
        this.position = response.position;
      }).catch(err =>{
        console.log(err);
        this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      });

    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

    this.geofences = [];
    this.geofenceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.geofences.forEach(item => {
        this.geofences.push(item);
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });
    this.geofence = {type:"C",circle:{radius:1000},line:{distance:5},polygon:{}};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayGeofence = false;
    this.displayDevices = false;
  }

  isValidPolygon(){
    if(this.geofence.type == "C"){
      return this.circle !=null;

    }else if(this.geofence.type == "L"){
      return this.line !=null && this.line.getPath().getLength()>=2;
    }else if(this.geofence.type == "P"){
      return this.polygon!=null && this.polygon.getPath().getLength()>=3;
    }
  }
  isDevicesSelected(){
    return this.devicesSelecteds.length > 0;
  }

  nextStep(){
    this.activeIndex++;
  }

  prevStep(){
    this.activeIndex--;
  }

  handleMapClick(event) {
    if(this.geofence.type == "C"){
      this.overlays=[];
      this.circle = new google.maps.Circle({center: event.latLng, fillColor: '#1976D2', fillOpacity: 0.35, strokeWeight: 1, radius: this.geofence.circle.radius,draggable: true});
      this.overlays.push(this.circle);
    }else if(this.geofence.type == "L"){
      if(this.line == null){
        this.overlays=[];
        this.line = new google.maps.Polyline({
          geodesic: true,
          strokeColor: '#1976D2',
          strokeOpacity: 0.35,
          strokeWeight: this.geofence.line.distance,
          editable: true
        });
        this.overlays.push(this.line);
      }
      this.line.getPath().push(event.latLng);
    }else if(this.geofence.type == "P"){
      if(this.polygon==null){
        this.overlays=[];
        this.polygon = new google.maps.Polygon({
          strokeColor: '#1976D2',
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: '#1976D2',
          fillOpacity: 0.35,
          editable: true
        });
        this.overlays.push(this.polygon);
      }
      this.polygon.getPath().push(event.latLng);
    }
  }

  changeRadius(event){
    this.circle.setRadius(this.geofence.circle.radius);
  }

  changeDistance(event){
    if(this.line!=null){
      this.line.setOptions({
        geodesic: true,
        strokeColor: '#1976D2',
        strokeOpacity: 0.35,
        strokeWeight: this.geofence.line.distance
      });
    }
  }

  setMap(event) {
    this.map = event.map;
    this.map.setCenter(new google.maps.LatLng(this.position.latitude, this.position.longitude));
    if(this.geofence !=null && this.displayEdit){
      if(this.geofence.type == "C"){
        this.map.setCenter(new google.maps.LatLng(this.geofence.circle.centerLatitude,this.geofence.circle.centerLongitude))
      }else if(this.geofence.type == "L"){
        this.map.setCenter(new google.maps.LatLng(this.geofence.line.coordinates[0].latitude,this.geofence.line.coordinates[0].longitude));
      }else if(this.geofence.type == "P"){
        this.map.setCenter(new google.maps.LatLng(this.geofence.polygon.coordinates[0].latitude,this.geofence.polygon.coordinates[0].longitude));
      }
    }
  }

  showAdd(){
    this.init();
    this.displayAdd = true;
  }

  showEdit(geofence:any){
    this.geofence=geofence;
    this.displayEdit = true;
  }

  showGeofence(geofence:any){
    this.geofence=geofence;
    this.displayGeofence = true;
    this.overlays=[];
    if(this.geofence.type == "C"){
      this.circle = new google.maps.Circle({center: new google.maps.LatLng(this.geofence.circle.centerLatitude,this.geofence.circle.centerLongitude), fillColor: '#1976D2', fillOpacity: 0.35, strokeWeight: 1, radius: this.geofence.circle.radius,draggable: true});this.overlays.push(this.circle);
      setTimeout(()=> { // map will need some time to load
        this.map.setCenter(new google.maps.LatLng(this.geofence.circle.centerLatitude,this.geofence.circle.centerLongitude));
      }, 1000);
    }else if(this.geofence.type == "L"){
      this.line = new google.maps.Polyline({
        geodesic: true,
        strokeColor: '#1976D2',
        strokeOpacity: 1.0,
        strokeWeight: this.geofence.line.distance,
        editable: true
      });
      let latLng;
      this.geofence.line.coordinates.forEach(item => {
        this.line.getPath().push(new google.maps.LatLng(item.latitude, item.longitude));
        latLng = new google.maps.LatLng(item.latitude, item.longitude);
      });
      this.overlays.push(this.line);
      setTimeout(()=> { // map will need some time to load
        this.map.setCenter(latLng);
      }, 1000);
    }else if(this.geofence.type == "P"){
      this.polygon = new google.maps.Polygon({
        strokeColor: '#1976D2',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#1976D2',
        fillOpacity: 0.35,
        editable: true
      });
      let latLng;
      this.geofence.polygon.coordinates.forEach(item => {
        this.polygon.getPath().push(new google.maps.LatLng(item.latitude, item.longitude));
        latLng = new google.maps.LatLng(item.latitude, item.longitude);
      });
      this.overlays.push(this.polygon);
      setTimeout(()=> { // map will need some time to load
        this.map.setCenter(latLng);
      }, 1000);
    }
  }

  clean(){
    this.overlays=[];
    this.circle = null;
    this.line=null;
    this.polygon=null;
  }

  showDevices(geofence:any){
    this.geofence=geofence;
    this.displayDevices = true;
    this.devicesAvailables = [];
    this.devicesSelecteds = [];
    this.deviceService.findByUser(this.userService.userLoged.idUser).then(data => {
      let response: any = data;
      response.devices.forEach(item => {
        this.devicesAvailables.push(item);
      });
      geofence.devices.forEach(item => {
        this.devicesSelecteds.push(item);
        let indice = -1;
        let i = 0;
        this.devicesAvailables.forEach(available => {
          if(item.idDevice == available.idDevice){
            indice = i;
          }
          i++;
        });
        if(indice> -1){
          this.devicesAvailables.splice(indice,1);
        }
      });
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
    });

  }

  hide(){
    this.activeIndex = 0;
    this.geofence = {type:"C",circle:{radius:1000},line:{distance:5},polygon:{}};
    this.displayAdd = false;
    this.displayEdit = false;
    this.displayGeofence = false;
    this.displayDevices = false;
    this.circle = null;
    this.line = null;
    this.polygon=null;
    this.overlays=[];
    this.init();
  }

  add(){
    this.geofence.idUser = this.userService.userLoged.idUser;
    this.blockedDocument = true;
    if(this.geofence.type == 'C'){
      this.geofence.circle.centerLatitude = this.circle.getCenter().lat();
      this.geofence.circle.centerLongitude = this.circle.getCenter().lng();
    }else if(this.geofence.type == 'L'){
      this.geofence.line.coordinates = [];
      this.line.getPath().forEach(item => {
        this.geofence.line.coordinates.push({latitude:item.lat(),longitude:item.lng()});
      });
    }else if(this.geofence.type == 'P'){
      this.geofence.polygon.coordinates = [];
      this.polygon.getPath().forEach(item => {
        this.geofence.polygon.coordinates.push({latitude:item.lat(),longitude:item.lng()});
      });
    }
    this.geofence.devices = [];
    this.devicesSelecteds.forEach(item => {
      this.geofence.devices.push(item);
    });
    this.geofenceService.create(this.geofence).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro insertado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  edit(){
    this.blockedDocument = true;
    if(this.geofence.type == 'C' && this.circle !=null){
      this.geofence.circle.centerLatitude = this.circle.getCenter().lat();
      this.geofence.circle.centerLongitude = this.circle.getCenter().lng();
    }else if(this.geofence.type == 'L' && this.line!=null){
      this.geofence.line.coordinates = [];
      this.line.getPath().forEach(item => {
        this.geofence.line.coordinates.push({latitude:item.lat(),longitude:item.lng()});
      });
    }else if(this.geofence.type == 'P' && this.polygon!=null){
      this.geofence.polygon.coordinates = [];
      this.polygon.getPath().forEach(item => {
        this.geofence.polygon.coordinates.push({latitude:item.lat(),longitude:item.lng()});
      });
    }

    if(this.devicesSelecteds != null || this.devicesSelecteds.length > 0){
      this.geofence.devices = [];
      this.devicesSelecteds.forEach(item => {
        this.geofence.devices.push(item);
      });
    }
    this.geofenceService.edit(this.geofence).then(data =>{
      let response: any = data;
      if(response.status == 'OK'){
        this.init();
        this.msgs = [{severity:'info', summary:'INFO', detail:'Registro modificado exitosamente'}];
      }else{
        this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
      }
      this.blockedDocument = false;
    }).catch(err =>{
      console.log(err);
      this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
      this.blockedDocument = false;
    });
  }

  del(id: number){
    this.confirmationService.confirm({
      message: 'Esta seguro de eliminar el registro seleccionado?',
      header: 'Confirmación',
      icon: 'fa fa-trash',
      accept: () => {
        this.blockedDocument = true;
        this.geofenceService.remove(id).then(data =>{
          let response: any = data;
          if(response.status == 'OK'){
            this.init();
            this.msgs = [{severity:'info', summary:'INFO', detail:'Registro eliminado exitosamente'}];
          }else{
            this.msgs = [{severity:'error', summary:'ERROR', detail:response.message}];
          }
          this.blockedDocument = false;
        }).catch(err =>{
          console.log(err);
          this.msgs = [{severity:'error', summary:'ERROR', detail:"Existe algun problema con la conexión al servidor"}];
          this.blockedDocument = false;
        });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/geofence/geofence.component.ts